// extracted by mini-css-extract-plugin
module.exports = {"errors":"_5DK9ijRq"};